import http from '@util/http';
import { common } from '@api/req';

export async function querySaveAttachment(params) {
  return http.post(common.ATTCHMENT_SAVE, params);
}
export async function queryDeleteAttachment(params) {
  return http.get(common.ATTCHMENT_DELETE, params);
}
export async function queryFileList(params) {
  return http.get(common.FILE_LIST, params);
}
export async function queryFilePreview(file, waterMark) {
  http.html(common.READONLINE, { uuid: file.uuid, waterMark: waterMark || '' });
}



// WEBPACK FOOTER //
// ./src/api/pub/attachment.js